<template>
  <div>
    <div class="card">
      <header class="header-card">
        <p>{{ $t('addEditTypeOt.infoGenerale.title')}}</p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <b-field
            :label="$t('addEditTypeOt.infoGenerale.libelle')"
            class="column is-4 obligatoire">
            <b-input v-model="typeOt.libelle"/>
          </b-field>

          <b-field
            :label="$t('addEditTypeOt.infoGenerale.actionIntervention')"
            class="column is-4 obligatoire">
            <b-select v-model="typeOt.actionInterventionOt" expanded>
              <option
                v-for="action in actionsInterventionsTypes"
                :key="action.code"
                :value="action.code">
                {{ $t(action.libelle) }}
              </option>
            </b-select>
          </b-field>

          <b-field
            :label="$t('addEditTypeOt.infoGenerale.produit')"
            class="column is-4"
            :class="{'obligatoire': isActionImpressionAffiche}">
              <b-autocomplete
                v-model="searchRefProduit"
                :data="produits"
                field="reference"
                @select="actionSelectProduit"
                @typing="getProduits"
                :loading="isFetching" >
                <template slot="empty">
                  <div v-if="!isFetching">{{$t('general.autocomplete.noRslt')}}</div>
                  <div v-else>{{$t('general.autocomplete.search')}}</div>
                </template>
              </b-autocomplete>
          </b-field>
          <b-field class="column is-4" v-if="moduleImpressionActive"
             :label="$t('addEditTypeOt.infoGenerale.isVisibleInSuiviProduction')">
            <qd-switch v-model="typeOt.isVisibleInSuiviProduction"/>
          </b-field>
          <b-field class="column is-4" v-if="moduleImpressionActive"
            :label="$t('addEditTypeOt.infoGenerale.couleur')">
            <colorPicker
              v-model="typeOt.couleur"
              :isIcon="false"
              :size="30"
              :palette="palette">
            </colorPicker>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import {
  LISTE_ACTION_INTERVENTION,
  LISTE_ACTION_INTERVENTION_DISPOSITF,
  LISTE_ACTION_INTERVENTION_IPRESSIONAFFICHE,
  IMPRESSION_AFFICHE,
} from '@/configuration/logistique/typeOt/typeOtConfig';
import { SENS_ACHAT } from '@/configuration/devisConf';
import { getAll as getAllProduit } from '@/api/produit';
import messageErreur from '@/services/general/messageErreur';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import colorPicker from '@/components/general/button/colorPicker';
import { PALETTE_TYPE_OT } from '@/configuration/general/couleurConf';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    typeOt: {
      type: Object,
      required: true,
    },
  },
  components: {
    colorPicker,
  },
  data() {
    return {
      constantes: {
        LISTE_ACTION_INTERVENTION,
        IMPRESSION_AFFICHE,
      },
      isFetching: false,
      produits: [],
      searchRefProduit: '',
      palette: PALETTE_TYPE_OT,
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    moduleStockTiersActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleStockTiers.key);
    },
    moduleImpressionActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.demandeImpression.key);
    },
    listeActionIntervenants() {
      return this.moduleStockTiersActive ? this.constantes.LISTE_ACTION_INTERVENTION
        : this.constantes.LISTE_ACTION_INTERVENTION
          .filter(action => action.code !== this.constantes.IMPRESSION_AFFICHE);
    },
    isActionImpressionAffiche() {
      return this.typeOt.actionInterventionOt === this.constantes.IMPRESSION_AFFICHE;
    },
    actionsInterventionsTypes() {
      let types = LISTE_ACTION_INTERVENTION;
      if (this.moduleEmplacementClientActive) {
        types = types.concat(LISTE_ACTION_INTERVENTION_DISPOSITF);
      }
      if (this.moduleStockTiersActive) {
        types = types.concat(LISTE_ACTION_INTERVENTION_IPRESSIONAFFICHE);
      }
      return types;
    },
    moduleEmplacementClientActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    getProduits: debounce(async function produits() {
      this.produits = [];
      if (!this.searchRefProduit) return;
      const societeId = this.typeOt.societeId || this.societeActiveId;
      this.isFetching = true;
      const query = {
        query: {
          societeId,
          sens: SENS_ACHAT,
          actif: true,
          references: [this.searchRefProduit],
        },
      };
      this.produits = (await getAllProduit(query)).data.result.items;
      this.isFetching = false;
    }, 500),
    actionSelectProduit(option) {
      this.typeOt.produitId = option.id;
      if (this.typeOt.id) {
        this.typeOt.produit = {
          id: option.id,
          reference: option.reference,
          libelle: option.libelle,
        };
      }
    },
  },
  async mounted() {
    try {
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key,
        PARAMETRES_INTERNE_KEYS.moduleStockTiers.key,
        PARAMETRES_INTERNE_KEYS.demandeImpression.key,
      ]);
      if (this.typeOt.produitId) {
        this.searchRefProduit = this.typeOt.produit.reference;
      }
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
